import { useEffect, useLayoutEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import "@/index.css";
import { Analytics } from "@/lib/analyticsShim";

import { AuthProvider } from "@/contexts/AuthContext";
import { CartProvider } from "@/contexts/CartContext";
import { Toaster } from "@/components/ui/sonner";

import Landing from "@/pages/Landing";
import ProductDashboard from "@/pages/ProductDashboard";
import StructuralSteelDashboard from "@/pages/StructuralSteelDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import Orders from "@/pages/Orders";
import VendorOrders from "@/pages/VendorOrders";
import Profile from "@/pages/Profile";
import Login from "@/pages/Login";
import Register from "@/pages/Register";

function ScrollToTop() {
  const { pathname, search, hash } = useLocation();

  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
  }, []);

  useLayoutEffect(() => {
    if (pathname === "/" && hash) return undefined;

    const scrollToPageTop = () => {
      window.scrollTo(0, 0);
      document.scrollingElement?.scrollTo?.(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    };

    scrollToPageTop();
    const frameId = window.requestAnimationFrame(scrollToPageTop);
    const timers = [0, 80, 220].map((delay) => window.setTimeout(scrollToPageTop, delay));

    return () => {
      window.cancelAnimationFrame(frameId);
      timers.forEach((timer) => window.clearTimeout(timer));
    };
  }, [pathname, search, hash]);

  return null;
}

function App() {
  useEffect(() => {
    document.title = "RailAxis — B2B Railway & Construction Materials";
  }, []);

  return (
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/products/structural-steel" element={<StructuralSteelDashboard />} />
            <Route path="/products/structural-steel/:categoryId" element={<StructuralSteelDashboard />} />
            <Route path="/products/:slug" element={<ProductDashboard />} />
            <Route path="/admin-dashboard" element={<AdminDashboard />} />
            <Route path="/orders" element={<Orders />} />
            <Route path="/vendor-orders" element={<VendorOrders />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
          </Routes>
          <Toaster position="top-right" richColors />
          <Analytics />
        </BrowserRouter>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
